import { MapPin } from "lucide-react"
import { forwardRef } from "react"
import { cn } from '@/utils/index'
import { InputProps } from "@/components/atoms/Input/input"

export interface SearchInputProps extends InputProps {
  borderless?: boolean
  dashboardInput?: boolean
}

const SearchInput = forwardRef<HTMLInputElement, SearchInputProps>(({
  placeholder,
  className,
  borderless,
  dashboardInput,
  ...props
}, ref) => {
  if (dashboardInput) return (
    <input
      {...props}
      ref={ref}
      className={className}
      type="text"
      placeholder={placeholder}
    />
  )

  return (
    <div className={`relative bg-transparent text-lg text-gray-400 lg:text-gray-700 dark:text-gray-200 ${borderless && "lg:border-r-2"}`}>
      <div className={`flex items-center border-b lg:border-black py-5 dark:border-white ${borderless && "border-none"}`}>
        <MapPin className="p absolute left-0 top-0 mt-5 w-5 h-5" />
        <input
          {...props}
          ref={ref}
          className={cn("ml-3 text-wrap border-none bg-transparent px-2 leading-tight focus:outline-none", className)}
          type="text"
          placeholder={placeholder}
        />
      </div>
    </div>
  )
})

export default SearchInput